import { store } from 'flow/configure-store';
import { getFocusedActiveCall } from 'flow/selectors/call-selectors';
import { ActiveCallDirections } from 'flow/utils/call-utils';

export const BANKID_CALL_INITIATOR = 'bankid_callInitiator';
export const PHONE_NUMBER = 'phonenumber';
export const SESSION_ID = 'sessionId';

/**
 * Appends the DIRECTION parameter to the URL of call widgets with appType 'APP_BANKID'.
 *
 * @param {Array} callWidgetList - The list of call widgets.
 * @returns {Array} The updated callWidgetList with appended DIRECTION parameter.
 */
export const appendBankIDAPPwithDirection = (callWidgetList) => {
    callWidgetList.forEach((callWidget) => {
        const { additionalProperties, url } = callWidget;
        // Check if the 'additionalProperties' object contains the key 'appType' with value 'APP_BANKID'
        if (
            additionalProperties &&
            additionalProperties?.appType === 'APP_BANKID'
        ) {
            const callWidgetURL = new URL(
                `${url}&${BANKID_CALL_INITIATOR}={DIRECTION}&${SESSION_ID}={SESSION_ID}`,
            );
            callWidget.url = callWidgetURL.href;
        }
        return callWidget;
    });

    return callWidgetList;
};

/**
 * Replaces the DIRECTION and PHONE_NUMBER parameters in the given URL with
 * the direction and phone number values of the active call.
 *
 * @param {string} url - The original URL.
 * @returns {string|null} The updated URL with the replaced parameters,
 * or null if no active call is found
 * or if there is an error parsing the URL.
 */
export const replaceCallInitiatorKeyAndNumber = (url) => {
    const state = store.getState();
    const activeCall = getFocusedActiveCall(state);

    // Return null if no active call is found
    if (!activeCall || Object.keys(activeCall).length === 0) {
        return null;
    }

    const direction = activeCall.get('direction');
    let directionValue;
    let phoneNumber;

    switch (direction) {
        case ActiveCallDirections.INCOMING.value:
            directionValue = 'incoming';
            phoneNumber = activeCall.get('source');
            break;
        case ActiveCallDirections.OUTGOING.value:
            directionValue = 'outgoing';
            phoneNumber = activeCall.get('destination');
            break;
        default:
            return null;
    }

    try {
        // Use a try-catch block to handle potential URL parsing errors
        const urlObject = new URL(url);
        urlObject.searchParams.set(BANKID_CALL_INITIATOR, directionValue);
        urlObject.searchParams.set(PHONE_NUMBER, phoneNumber);
        urlObject.searchParams.set(
            SESSION_ID,
            activeCall.get('locutusSessionId'),
        );
        return urlObject.toString();
    } catch (error) {
        console.error('Error parsing URL:', error.message);
        return null;
    }
};
